import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalValueService {
  mainCategory: any;
  subCategory: any;

  constructor() { }
}
